export const ROUTES = {
  DASHBOARD: "/dashboard",
  BUSINESS: "/business",
  BRANCH: "/branch",
  TOPICS: "/topics",
  CHATS: "/chats",
  USERS: "/users",
  CALENDAR: "/calendar",
  ADVISOR: "/advisor",
  TEAM: "/team",
  CUSTOMERS: "/customers",
  SIGNIN: "/auth/signin",
  SIGNUP: "/auth/signup",
  NOT_FOUND: "/404",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS: "/terms",
  GDPR_POLICY: "/gdpr-policy",
  COMPLIANCE: "/compliance",
  LANDING: "/",
  DOCUMENTATION: "/documentation",
  MEETING_ROOM: "/meeting-room",
  EXCEL: "/excel",
  BILLING: "/billing",
  POSTER: "/poster",
  SPREADSHEET: "/spreadsheet",
  OPENSIGN: "/opensign",
  TASKS: "/tasks",
  BLOGS: "/blogs",
};
